export const PATH = {
  INDEX: "/",
  HOME: "/home",
  LOGIN: "/login",
  OTP: "/otp",
  AUTH_SUCCESS: "/auth-success",
  ID_PASSPORT: "/id-passport",
  ID_PASSPORT_SCANNING: "/id-passport-scanning",
  TAKE_PHOTO: "/take-photo",
  PERSONAL_INFORMATION: "/personal-information",
  FATCA_CRS: "/fatca-crs",
  PREVIEW: "/preview",
  FORM_AGREEMENTS: "/form-agreements",
  AGREEMENT: "/agreement",
  PRINT_CHECKLIST: "/print-checklist",
  CONFIRMATION: "/confirmation",
  QUALIFIED_CONFIRMATION: "/qualified-confirmation",
  PAYMENT: "/payment",
  PAYMENT_SUCCESS: "/payment-success",
  PAYMENT_FAIL: "/payment-fail",
};

// export const STEPS = {
//   AUTH: 'auth',
// };

export const FORM_KEYS = {
  FORM_OPTIONS: "formOptions",
  ID_PASSPORT: {
    FULL_NAME: "fullName",
    IS_WITH_CIVIL_ID: "isWithCivilId",
    CIVIL_ID: "civilId",
    PASSPORT_ID: "passportId",
    SELFIE: "selfie",
    CIVIL_ID_FRONT: "civilIdFront",
    CIVIL_ID_BACK: "civilIdBack",
    PASSPORT: "passport",
    TO_BE_EMAILED: "tobeEmailed",
  },
  CLIENT_DETAILS: {
    CLIENT_CLASSIFICATION: "clientClassification",
    QUALIFIED_INVESTOR: "qualifiedInvestorOptions",
    TYPE_OF_INVESTMENT: "typeOfInvestment",
    PRODUCT: "product",
    NATIONALITY: "nationality",
    DATE_OF_BIRTH: "dateOfBirth",
    CITY_OF_BIRTH: "cityOfBirth",
    COUNTRY_OF_BIRTH: "countryOfBirth",
    OCCUPATION: "occupation",
    HOME_ADDRESS: "homeAddress",
    COUNTRY_OF_RESIDENCE: "countryOfResidence",
    EMAIL_ADDRESS: "emailAddress",
    MOBILE: "mobileNumber",
    EMPLOYER_BUSINESS_NAME: "employerBusinessName",
    POSITION: "position",
    OFFICE_ADDRESS: "officeAddress",
    MUTUAL_FUND_QUALIFIED: "mutualFundQualified",
    INVESTMENT_STRATEGY: "investmentStrategies",
    ASSET_ALLOCATIONS: "assetAllocations",
    INVESTED_AMOUNT: "investedAmount",
    INVESTED_UNIT_TO_AMOUNT: "bufferedInvestmentAmount",
    EDUCATION_LEVEL: "educationLevel",
    OTHER_EDUCATION_LEVEL: "otherEducationLevel",
    OTHER_NATIONALITY_PASSPORT: "otherCivilIdOrPassport",

    // New fields (Calculation for invested amount)
    // BUFFERED_INVESTMENT_AMOUNT: 'bufferedInvestmentAmount',
    BUFFERED_INVESTMENT_UNITS: "bufferedInvestmentUnits",
    INVESTMENT_UNIT_TYPE: "investmentUnitType",
    INVESTMENT_UNITS: "investmentUnits",
    ARABIC_FUND_NAME: "arabicFundName",
    EN_FUND_NAME: "enFundName",
    PRODUCT_BANK_DETAILS: "productBankDetails",
    AOA: "aoa",
  },
  PEP: {
    IS_PEP: "isPep",
    BENEFICIARIES: "list",
    NAME: "name", // dynamic
    CURRENT_FORMER_OPTION: "currentFormerOption", // dynamic
    POSITION: "position",
    OTHER_POSITION: "otherPosition",
    RELATIONSHIP: "relationship", // dynamic
  },
  BANK: {
    BANK_NAME: "bankName",
    OTHER_BANK_NAME: "otherBankName",
    DOMICILE_COUNTRY: "domicileCountry",
    ACCOUNT_NAME: "accountName",
    IBAN: "iban",
    NON_IBAN: "iban",
    CURRENCY: "currency",
    BANK_ACCT_FORMAT: "isWithIban",
    SWIFT_NUMBER: "swift",
    ROUTING_NUMBER: "routingNumber",
    USING_KNET: "usingKNET",
    CARD_INFO: "cardInfo",
  },
  SOURCE_OF_WEALTH: {
    ESTIMATED_WEALTH: "estimatedWealth",
    ESTIMATED_WEALTH_APPROX_VAL: "estimatedWealthApproxValue",
    WEALTH_FUNDS: "sourceOfWealthFunds",
    NET_ASSETS: "netAssets",
    NET_INCOME: "netIncome",
    NET_INCOME_APPROX_VAL: "netIncomeApproxValue",
    OTHER_SOURCE_OF_WEALTH: "otherSourceOfWealth",

    OTHER_SOURCE_OF_WEALTH_FIELDS: "sourceOfWealthFundsDetails",
    // @Note new fields (which will be as JSON format for OTHER_SOURCE_OF_WEALTH_FIELDS)
    TOTAL_YRS_EXP: "totalYearOfExp",
    DETAIL_OF_REL: "detailsOfRelationShip",
    YR_OR_INHERITANCE: "yearOfInheritance",
    APPROX_VAL_OF_INHERITANCE: "approxValueOfInherited",
    TYPE_ASSET_MARKET: "typesOfAssetsAndMarkets",
    APPROX_VAL_INV_SAV: "approxValueOfInvestmentsAndSavings",
    DETAIL_OF_BIZ: "detailsOfBusinessName",
    TYPE_OF_ACT: "typeOfActivity",
    APPROX_VAL_REV: "approxValueOfRevenues",
  },
  ASI: {
    IS_AUTHORITY_TO_DEAL: "authorityToDeal",
    POA_HOLDER: "isPOAholder",
    NAME: "poaName",
    ADDRESS: "poaAddress",
    EMAIL_ADDRESS: "poaEmailAddress",
    NATIONALITY: "poaNationality",
    DOB: "poaDateOfBirth",
    OCCUPATION: "poaOccupation",
    POSITION: "poaPosition",
    COUNTRY_CODE_MOBILE: "poaMobileCC",
    MOBILE: "poaMobile",
    HOME_NUMBER: "poaHomeNumber",
    COUNTRY_CODE_HOME_NUMBER: "poaHomeNumberCC",
    EMPLOYER_BUSINESS_NAME: "poaEmployerBusinessName",
    RELATIONSHIP_WITH_CLIENT: "poaRelationshipWithClient",
    IS_AS_US_PERSON: "poaIsAsUSPerson",
  },
  CLIENT_PROFILE_FORM: {
    WITH_INVESTMENT_EXP: "withInvestmentExp",
    GOAL: "goal",
    INVESTMENT_PURPOSE: "investmentPurpose",
    INVESTMENT_PURPOSE_OTHERS: "investmentPurposeOthers",
    RISK_TOLERANCE: "riskTolerance",
    INVESTMENT_PREFERENCE: "investmentPreference",
    INVESTMENT_EXP_BONDS_YRS: "ieBondsYrs",
    INVESTMENT_EXP_BONDS_STRATEGY: "ieBondsStrategy",
    INVESTMENT_EXP_EQUITIES_YRS: "ieEquitiesYrs",
    INVESTMENT_EXP_EQUITIES_STRATEGY: "ieEquitiesStrategy",
    INVESTMENT_EXP_DERIVATIVES_YRS: "ieDerivativesYrs",
    INVESTMENT_EXP_DERIVATIVES_STRATEGY: "ieDerivativesStrategy",
    INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS:
      "iePrivateEquityHedgeFundsYrs",
    INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_STRATEGY:
      "iePrivateEquityHedgeFundsStrategy",
    INVESTMENT_EXP_REAL_ESTATE_YRS: "ieRealEstateYrs",
    INVESTMENT_EXP_REAL_ESTATE_STRATEGY: "ieRealEstateStrategy",
    INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS: "ieOtherAlternativeInvestmentsYrs",
    INVESTMENT_EXP_OTHER_ALTERNATIVE_STRATEGY:
      "ieOtherAlternativeInvestmentsStrategy",
    INDEPENDENT_PROF_ADVICE: "independentProfAdvice",
    INSIDER_STATUS: "insiderStatus",
    INSIDER_STATUS_LIST: "insiderStatusList",
    INSIDER_STATUS_LIST_COMPANY: "insiderCompany", // dynamic
    INSIDER_STATUS_LIST_POSITION: "insiderPosition", // dynamic
    INVESTMENT_OBJECTIVE_TIME_HORIZON: "investmentObjectiveTimeHorizon",
    ASSET_CLASSES: "assetClasses",
    MARKETS: "markets",
    // LIQUIDITY_INVESTMENT_MATURITY_TARGETS: 'liquidityInvestmentMaturityTargets',
    INVESTMENT_KNOWLEDGE: "investmentKnowledge",
    RESTRICTIONS: "restrictions",
    OTHER_RESTRICTION: "otherRestriction",
    // OTHER_SECTOR: 'otherSector',
    // OTHER_ISSUER: 'otherIssuer',
  },
  FATCA: {
    FATCA_Q1: "fatcaQ1",
    FATCA_Q2: "fatcaQ2",
    FATCA_Q3: "fatcaQ3",
    FATCA_Q4: "fatcaQ4",
    FATCA_Q5: "fatcaQ5",
    FATCA_Q6: "fatcaQ6",
    STATE: "state",
    CITY: "city",
    ADDRESS: "address",
    US_PHONE: "usPhone",
    NATIONALITY: "nationality",
    BENEFICIARY: "beneficiary",
    NAME_OF_PERSON: "name",
  },
  CRS: {
    CRS_Q1: "crsQ1",
    CRS_Q2: "crsQ2",
    CRS_Q3: "crsQ3",
    CRS_Q4: "crsQ4",
    CRS_Q5: "crsQ5",
    CRS_Q6: "crsQ6",
    RESIDENT_REPORTABLE_JURISDICTION: "residentOfReportableJurisdiction",
    RESIDENCE_ADDRESS: "residenceAddress",
    TELEPHONE_NUMBER: "telephoneNumber",
    HOLD_MAIL: "holdMail",
    STANDING_INSTRUCTION: "standingInstruction",
    EFFECTIVE_POA: "effectivePoa",
  },
  COUNTRY_TAX: {
    COUNTRY_JURISDICTION: "countryJurisdiction",
    IS_TIN: "isTin",
    TIN: "tin",
    REASON_OPTION: "reasonOption",
    REASON_TIN_NOT_ISSUED: "reasonNotIssued",
  },
  AGREEMENT: {
    AOF_KYC: "aofKyc",
    PROFILE: "profile",
    AOF_KYC_PROFILE_SIGNATURE: "aofKycProfileSignature",
    AOF_KYC_PROFILE_TIMESTAMP: "aofKycProfileTimestamp",
    AOF_KYC_PROFILE_TIMESTAMP_UTC: "aofKycProfileTimestampUTC",
    // ACKNOWLEDGEMENT: 'acknowledgementUndertaking',
    NDPF: "ndpf",
    PROPOSED_PLAN: "proposedPlan",
    NDPF_PROPOSED_PLAN_SIGNATURE: "ndpfProposedPlanSignature",
    NDPF_PROPOSED_PLAN_TIMESTAMP: "ndpfProposedPlanTimestamp",
    NDPF_PROPOSED_PLAN_TIMESTAMP_UTC: "ndpfProposedPlanTimestampUTC",
    IS_AGREEMENT_READY_FOR_QUALIFIED: "isAgreementReadyForQualified",
    IS_CUSTOM_AA_UPLOADED: "customAssetAllocationUploaded",
  },
  APPLICANT: {
    APPLICANT_ID: "applicantId",
    PHONE_NUMBER: "phoneNumber",
    IS_EMAIL_SENT: "emailSent",
    IS_COMPLETED: "isCompleted",
  },
};

export const CLIENT_CLASSIFICATION = {
  RETAIL: "NW-MAR-CLA-RET", // retail
  QUALIFIED: "NW-MAR-CLA-QUA", // qualified
  IMARKAZ_RETAIL: "NW-MAR-CLA-IMA-RET",
  IMARKAZ_RETAIL_POA: "NW-MAR-CLA-IMA-RET-POA",
  IMARKAZ_RETAIL_MINOR: "NW-MAR-CLA-IMA-RET-MIN",
  IMARKAZ_QUALIFIED: "NW-MAR-CLA-IMA-QUA",
  IMARKAZ_QUALIFIED_POA: "NW-MAR-CLA-IMA-QUA-POA",
  IMARKAZ_QUALIFIED_MINOR: "NW-MAR-CLA-IMA-QUA-MIN",
  COB_RETAIL: "NW-MAR-CLA-COB-RET",
  COB_RETAIL_POA: "NW-MAR-CLA-COB-RET-POA",
  COB_RETAIL_MINOR: "NW-MAR-CLA-COB-RET-MIN",
  COB_QUALIFIED: "NW-MAR-CLA-COB-QUA",
  COB_QUALIFIED_POA: "NW-MAR-CLA-COB-QUA-POA",
  COB_QUALIFIED_MINOR: "NW-MAR-CLA-COB-QUA-MIN",
};

export const PRODUCT_SERVICE_TYPE = {
  INVESTMENT_SERVICE: "Investment Service",
  MUTUAL_FUND: "Mutual Fund",
  REAL_ESTATE: "Real Estate Product",
};

export const TAGS_TYPE = {
  CATEGORY1: "category1",
  CATEGORY2: "category2",
  INVESTOR_TYPE: "investorType",
};

export const TYPE_OF_INVESTMENT = {
  IMARKAZ_PORTFOLIO: "NW-MAR-TOI-MAR",
  MUTUAL_FUNDS: "NW-MAR-IEY-MUT",
  // OTHER_INVESTMENT_SERVICES: 'otherInvestmentServices',
};

export const QUALIFIED_TYPE_OF_INVESTMENT = {
  DISCRETIONARY: "NW-MAR-CLA-DIS",
  NON_DISCRETIONARY: "NW-MAR-CLA-NDIS",
  MUTUAL_FUNDS: "NW-MAR-CLA-MFT",
  CUSTODY: "NW-MAR-CLA-CUS",
};

export const INVESTMENT_STRATEGY = {
  MENA_EQUITIES_ABSOLUTE: "NW-MAR-IVS-MA",
  MENA_EQUITIES_ABSOLUTE_SHARIA: "NW-MAR-IVS-MAS",
  DIVIDEND_YIELD: "NW-MAR-IVS-DIV",
};

export const ASSET_ALLOCATIONS = {
  IMARKAZ_PORTFOLIO: "NW-MAR-CLA-AA-MAR",
  INTERNATIONAL_REAL_ESTATE_PRODUCTS: "NW-MAR-CLA-AA-RE",
};

export const MUTUAL_FUND_SUBSCRIPTION = {
  MUMTAZ: "KW0EQ0903298", // 'NW-MAR-CLA-POR',
  ISLAMIC: "KW0EQ0903314", // 'NW-MAR-CLA-MUT',
  REAL_ESTATE: "LP65038182", // 'NW-MAR-CLA-RE',
};

export const OCCUPATIONS = {
  MINOR: "NW-MAR-OCC-MN",
  EMPLOYEE: "NW-MAR-OCC-EM",
  SELF_EMPLOYED: "NW-MAR-OCC-SEM",
  HOUSE_WIFE: "NW-MAR-OCC-HW",
  RETIRED: "NW-MAR-OCC-RE",
  OTHERS: "NW-MAR-OCC-OT",
};

export const SOURCE_OF_WEALTH_IDS = {
  SAL_PRO_INCOME_PENSION: "NW-MAR-SOW-SAL",
  INHERITANCE: "NW-MAR-SOW-INH",
  INV_SAVINGS: "NW-MAR-SOW-INV",
  TRADE_BIZ: "NW-MAR-SOW-TRA",
  OTHERS: "NW-MAR-SOW-OTH",
};

export const SOW_ESTIMATED_WEALTH_IDS = {
  BELOW_500K: "NW-MAR-ESW-ONE",
  ABOVE_10M: "NW-MAR-ESW-FIVE",
};

export const SOW_NET_INCOME_IDS = {
  BELOW_50K: "NW-MAR-NI-ONE",
  ABOVE_1M: "NW-MAR-NI-SIX",
};

export const GLOBAL = {
  YES: "Yes",
  NO: "No",
  CLIENT_MIN_AGE: 21,
  MIN_INVESTED_AMOUNT: 1,
  MAX_INVESTED_AMOUNT: 1000000,
};

export const NO_OF_CHARS = {
  SMALLEST_MIN: 2,
  MIN: 10,
  MIN_MOBILE: 6,
  SMALLEST_MAX: 50,
  MID: 75,
  MAX: 100,
  IBAN: 34,
};

export const APPLICANT_HISTORY_CODE = {
  COB_LOGIN: {
    code: "NW-MAR-COB-LOGIN",
    codeI18n: "nw.markaz.cob.action_type.login",
  },
  UPDATE_PROFILE: {
    code: "NW-MAR-UP-PRO",
    codeI18n: "nw.markaz.middle_office.action_type.update_profile",
  },

  SIGN_FATCA: {
    code: "NW-MAR-SI-FATCA",
    codeI18n: "nw.markaz.middle_office.action_type.sign_fatca_form",
  },
  SIGN_CRS: {
    code: "NW-MAR-SI-CRS",
    codeI18n: "nw.markaz.middle_office.action_type.sign_crs_form",
  },
  SIGN_CRM: {
    code: "NW-MAR-SI-CRM",
    codeI18n: "nw.markaz.middle_office.action_type.sign_crm_form",
  },

  FATCA_QUES: {
    code: "NW-MAR-FATCA-QUES",
    codeI18n: "nw.markaz.middle_office.action_type.fatca_questionnaires",
  },
  CRS_QUES: {
    code: "NW-MAR-CRS-QUES",
    codeI18n: "nw.markaz.middle_office.action_type.crs_questionnaires",
  },

  SIGN_PLAN: {
    code: "NW-MAR-SI-PLAN",
    codeI18n: "nw.markaz.middle_office.action_type.sign_proposed_plan",
  },
  SIGN_MAIN: {
    code: "NW-MAR-SI-MAIN",
    codeI18n: "nw.markaz.middle_office.action_type.sign_main_agreement",
  },
  SIGN_SUBA: {
    code: "NW-MAR-SI-SUBA",
    codeI18n: "nw.markaz.middle_office.action_type.sign_sub_agreement",
  },

  VERIFY_OTP: {
    code: "NW-MAR-OTP-SMS-VER",
    codeI18n: "nw.markaz.middle_office.action_type.verify_sms_otp_success",
  },
  VERIFY_OTP_EMAIL: {
    code: "NW-MAR-OTP-EMAIL-VER",
    codeI18n: "nw.markaz.middle_office.action_type.verify_email_otp_success",
  },
  SUBMIT_NAME: {
    code: "NW-MAR-SUB-NAME",
    codeI18n: "nw.markaz.middle_office.action_type.submit_fullName_civilId",
  },
  SUBMIT_SCANNING: {
    code: "NW-MAR-SUB-SCAN",
    codeI18n: "nw.markaz.middle_office.action_type.submit_id_scanning",
  },
  SUBMIT_DETAILS: {
    code: "NW-MAR-SUB-DET",
    codeI18n: "nw.markaz.middle_office.action_type.submit_client_details",
  },
  SUBMIT_PROFILE: {
    code: "NW-MAR-SUB-PROF",
    codeI18n: "nw.markaz.middle_office.action_type.submit_client_profile",
  },
  VIEW_AGREEMENT: {
    code: "NW-MAR-VIEW-AGR",
    codeI18n: "nw.markaz.middle_office.action_type.view_signed_agreements",
  },
};

export const STORAGE_KEY = {
  CURRENT_IP_DATA: "CURRENT_IP_DATA",
};

export const IS_LOGOUT = "IS_LOGOUT";

export const PDF_TYPE = {
  INVESTMENT_AGREEMENT: "ndpf",
  INVESTMENT_AGREEMENT_DPF: "dpf",
  MUTUAL_FUND_SUBSCRIPTION: "mft",
  NON_DISCRETIONARY_ASSET_ALLOCATION: "aa",
  DISCRETIONARY_MENA_ABSOLUTE: "dpf-absolute",
  DISCRETIONARY_MENA_SHARIA: "dpf-sharia",
  APPENDIX_1_PROPOSED_ALLOCATION: "markaz-cob-ndpf",
  CUSTODY: "cpf",
  DIVIDEND_YIELD: "dividend",
};

export const SIGNING_STATUS = {
  COMPLETE: "signing_complete",
};
